import {useEffect, useRef} from 'react';

type LockId = symbol;

const bodyScrollLockState = {
  activeLockIds: new Set<LockId>(),
  previousOverflowY: '',
};

function releaseBodyScrollLock(lockId: LockId): void {
  if (typeof document === 'undefined') {
    return;
  }

  if (!bodyScrollLockState.activeLockIds.has(lockId)) {
    return;
  }

  bodyScrollLockState.activeLockIds.delete(lockId);

  if (bodyScrollLockState.activeLockIds.size === 0) {
    document.body.style.overflowY = bodyScrollLockState.previousOverflowY;
  }
}

function acquireBodyScrollLock(lockId: LockId): void {
  if (typeof document === 'undefined') {
    return;
  }

  if (bodyScrollLockState.activeLockIds.has(lockId)) {
    return;
  }

  if (bodyScrollLockState.activeLockIds.size === 0) {
    bodyScrollLockState.previousOverflowY = document.body.style.overflowY;
    document.body.style.overflowY = 'hidden';
  }

  bodyScrollLockState.activeLockIds.add(lockId);
}

export function useBodyScrollLock(isEnabled: boolean = true): void {
  const lockIdRef = useRef<LockId | null>(null);

  if (lockIdRef.current === null) {
    lockIdRef.current = Symbol('body-scroll-lock');
  }

  const lockId = lockIdRef.current;

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    acquireBodyScrollLock(lockId);

    return () => {
      releaseBodyScrollLock(lockId);
    };
  }, [isEnabled, lockId]);
}
